import { useQuery } from 'react-query'
import { api } from '../api'
import { ProjectFormRevisionNumberValues, ProjectFormTypeEnum } from 'shared'
import { ApiUrlEnum } from '../../enums/ApiUrlEnum'
import { QueryKeyEnum } from '../../enums/QueryKeyEnum'

export const useGetProjectFormHeaderFooter = (
  projectId: string,
  projectFormType: ProjectFormTypeEnum,
) => {
  return useQuery({
    queryFn: () =>
      api.get<ProjectFormRevisionNumberValues>(
        `${ApiUrlEnum.PROJECT_FORM_HEADER_FOOTER}/${projectId}/${projectFormType}`,
      ),
    queryKey: [QueryKeyEnum.PROJECT_FORM_HEADER_FOOTER],
  })
}
